var _a;
import { Roadmap_Image_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Roadmap_Image_Type.Allergist] = 'Allergist',
    _a[Roadmap_Image_Type.BackPain] = 'Back Pain',
    _a[Roadmap_Image_Type.BloodTest] = 'Blood Test',
    _a[Roadmap_Image_Type.Chiropractor] = 'Chiropractor',
    _a[Roadmap_Image_Type.Dentist] = 'Dentist',
    _a[Roadmap_Image_Type.Dermatologist] = 'Dermatologist',
    _a[Roadmap_Image_Type.Endocrinologist] = 'Endocrinologist',
    _a[Roadmap_Image_Type.Gastroenterology] = 'Gastroenterologist (GI)',
    _a[Roadmap_Image_Type.General] = 'General',
    _a[Roadmap_Image_Type.Gynecologist] = 'OB-GYN',
    _a[Roadmap_Image_Type.HipPain] = 'Hip Pain',
    _a[Roadmap_Image_Type.KneePain] = 'Knee Pain',
    _a[Roadmap_Image_Type.Mri] = 'MRI',
    _a[Roadmap_Image_Type.Neurology] = 'Neurologist',
    _a[Roadmap_Image_Type.Ophthalmology] = 'Eye Doctor',
    _a[Roadmap_Image_Type.Orthodontist] = 'Orthodontist',
    _a[Roadmap_Image_Type.Orthopedics] = 'Orthopedic Surgeon',
    _a[Roadmap_Image_Type.Pediatrician] = 'Pediatrician',
    _a[Roadmap_Image_Type.PhysicalTherapy] = 'Physical Therapy',
    _a[Roadmap_Image_Type.Podiatrist] = 'Podiatrist',
    _a[Roadmap_Image_Type.PrimaryCareDoctor] = 'Primary Care Provider',
    _a[Roadmap_Image_Type.Psychiatrist] = 'Mental Health',
    _a[Roadmap_Image_Type.Radiology] = 'Radiology',
    _a[Roadmap_Image_Type.ShoulderPain] = 'Shoulder Pain',
    _a[Roadmap_Image_Type.Specialist] = 'Specialist',
    _a[Roadmap_Image_Type.UrgentCare] = 'Urgent Care',
    _a[Roadmap_Image_Type.WellnessVisit] = 'Wellness Visit',
    _a);
export var RoadmapImageTypeEnum = {
    name: 'Roadmap_Image_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
